<div class="user-filters-container">
  <!-- Campo de busca e botão de adicionar -->
  <div class="search-and-action-row">
    <mat-form-field class="search-field">
      <mat-label>Buscar por nome ou e-mail</mat-label>
      <input
        matInput
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchChange()"
        placeholder="Digite para buscar..."
      />
      <ng-container matSuffix>
        @if (searchText) {
          <button
            mat-icon-button
            (click)="clearSearch()"
            [attr.aria-label]="'Limpar texto'"
          >
            <mat-icon>close</mat-icon>
          </button>
        } @else {
          <mat-icon>search</mat-icon>
        }
      </ng-container>
    </mat-form-field>

    <button
      mat-flat-button
      color="primary"
      class="create-button"
      (click)="onCreateUser()"
    >
      <mat-icon>add</mat-icon>
      Cadastrar Usuário
    </button>
  </div>

  <!-- Filtros adicionais -->
  <div class="filters-row">
    <mat-form-field appearance="outline">
      <mat-label>Perfil</mat-label>
      <mat-select [(value)]="selectedRole" (selectionChange)="onRoleChange()">
        <mat-option value="">Todos</mat-option>
        @for (role of roles(); track role) {
          <mat-option [value]="role.value">
            {{ role.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select
        [(value)]="selectedStatus"
        (selectionChange)="onStatusChange()"
      >
        <mat-option value="">Todos</mat-option>
        @for (status of statuses(); track status) {
          <mat-option [value]="status.value">
            {{ status.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (showCompanyFilter()) {
      <mat-form-field appearance="outline">
        <mat-label>Empresa</mat-label>
        <mat-select
          [(value)]="selectedCompany"
          (selectionChange)="onCompanyChange()"
        >
          <mat-option value="">Todas</mat-option>
          @for (company of companies(); track company) {
            <mat-option [value]="company.value">
              {{ company.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <button mat-stroked-button (click)="onClearFilters()">
      <mat-icon>clear</mat-icon>
      Limpar Filtros
    </button>
  </div>
</div>
